import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { icons, miniToolsAnalyticGroups } from 'router/router';
import { useHistory, useLocation } from 'react-router';
import { getUserId } from 'utils/sessionStorage';

const MiniToolsAnalyticsMenu = () => {
  const history = useHistory();
  const location = useLocation();
  const [showSubmenu, setShowSubmenu] = useState<string | null>(null);
  const submenuRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const studentId = getUserId();

  // Handle click outside to close submenu
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node) &&
        submenuRef.current &&
        !submenuRef.current.contains(event.target as Node)
      ) {
        setShowSubmenu(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleIconClick = (route: any) => {
    if (route.isGroup === false) {
      history.push(route.route.path);
    } else {
      setShowSubmenu(showSubmenu === route.name ? null : route.name);
    }
  };

  const handleChildClick = (child: any) => {
    history.push(child?.path.replace(':id', studentId));
    setShowSubmenu(null);
  };

  const isActiveRoute = (route: any) => {
    const currentPath = location.pathname;
    
    if (route.isGroup === false) {
      const routePath = route.route.path.replace(':id', '');
      return currentPath === routePath || currentPath.startsWith(routePath);
    } else {
      return route.children.some((child: any) => {
        const childPath = child?.path.replace(':id', '');
        return currentPath === childPath || currentPath.startsWith(childPath);
      });
    }
  };

  const isChildActive = (child: any) => {
    return location.pathname.includes(child?.path.replace(':id', ''));
  };

  const renderSubmenu = (route: any) => {
    if (!showSubmenu || showSubmenu !== route.name) return null;

    return (
      <div
        ref={submenuRef}
        className="position-absolute bg-white border rounded shadow-sm"
        style={{
          left: '60px',
          top: '0',
          minWidth: '250px',
          zIndex: 1001,
          maxHeight: '400px',
          overflowY: 'auto'
        }}
      >
        <div className="p-2">
          <div className="fw-bold text-primary mb-2">{route.name}</div>
          {route.children.map((child: any, i: number) => {
            
            return (
              <div
                key={i}
                className={`d-flex align-items-center p-2 cursor-pointer rounded mini-submenu-item ${
                  isChildActive(child) ? 'bg-primary text-white' : ''
                }`}
                onClick={() => handleChildClick(child)}
                style={{ cursor: 'pointer' }}
              >
                <span className="me-2">{child?.icon}</span>
                <span className="flex-grow-1">{child?.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <div 
        ref={containerRef}
        className="h-100 d-flex flex-column bg-light border-end position-relative" 
        style={{ width: '60px' }}
      >
      <div className="flex-grow-1 d-flex flex-column py-2">
        {miniToolsAnalyticGroups.map((route: any, index: number) => {
          const IconComponent = icons[route.icon] || 'div';
          const isActive = isActiveRoute(route);
          return (
            <div key={index} className="position-relative">
                <Button
                  variant="outline"
                  className={`d-flex flex-column align-items-center justify-content-center mb-1 mx-1 border-0 position-relative mini-menu-item ${
                    isActive ? 'bg-primary text-white' : 'text-secondary'
                  }`}
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '8px'
                  }}
                  onClick={() => handleIconClick(route)}
                >
                  <IconComponent fontSize="small" />
                  </Button>
              
              {renderSubmenu(route)}
            </div>
          );
        })}
      </div>
    </div>
    <style>{`
      .mini-submenu-item:hover {
        background-color: #f8f9fa !important;
      }
    `}</style>
    </>
  );
};

export default MiniToolsAnalyticsMenu;
